/** @format */

'use strict';

// SalesFilter has edit layout enabled. Edit layout template url: salesfilter-dialog.html
// SalesFilter has detail layout enabled. Detail layout template url: salesfilter-detail.html
angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'SalesFilter'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('salesfilter'); // main translation loaded for salesfilter
		$translatePartialLoader.addPart('salesstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfiltereventtype'); // one to many reference from main entity
		$translatePartialLoader.addPart('salesfiltertemplateevent'); // one to many reference from main entity
		$translatePartialLoader.addPart('templateevent'); // reference of coupling entity with coupling extra field metadata
		$translatePartialLoader.addPart('user'); // one to many reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/salesfilter/salesfilter-dialog.html';

		return {
			/* new state for entity salesFilter */
			/* to access: ui-ref="salesfilter.list.new" */
			/* url: hostname/salesfilter/new */
			url: url,
			data: {
				authorities: [],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'SalesFilterDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'SalesFilterFactory',
									'NewSalesFilterFactory',
									function(SalesFilterFactory, NewSalesFilterFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new SalesFilter
										// - resuming the creation of a new new SalesFilter AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return SalesFilterFactory.get({ id: $stateParams.salesFilterId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewSalesFilterFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for salesFilter new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for salesFilter edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('salesfilter', {
		/* abstract state for entity salesFilter */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/salesfilter',
		data: {
			authorities: [],
			pageTitle: 'SalesFilters',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('salesfilter.list', {
		/* list state for entity salesFilter */
		/* to access: ui-ref="salesfilter.list" */
		/* url: hostname/salesfilter/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilters.html',
				controller: 'SalesFilterController',
			},
		},
	});

	$stateProvider.state('salesfilter.detail', {
		/* detail state for entity salesFilter */
		/* to access: ui-sref="salesfilter.detail" */
		/* url: hostname/salesfilter/detail/:salesFilterId */
		url: '/detail/:salesFilterId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-detail.html',
				controller: 'SalesFilterDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'SalesFilterFactory',
				function($stateParams, SalesFilterFactory) {
					return SalesFilterFactory.get({ id: $stateParams.salesFilterId });
				},
			],
		},
	});

	/* url: http://<hostname>/salesfilter/list/new */
	$stateProvider.state('salesfilter.list.new', getNewState());
	/* url: http://<hostname>/salesfilter/list/:salesFilterId/edit */
	$stateProvider.state('salesfilter.list.edit', getEditState('/:salesFilterId/edit'));
	/* url: http://<hostname>/salesfilter/detail/:salesFilterId/edit */
	$stateProvider.state('salesfilter.detail.edit', getEditState('/edit'));

	$stateProvider.state('user-salesfilter', {
		/* abstract state for DTO UserSalesFilterListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/salesfilter',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'SalesFilter',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase
			referredBy: null, // will be populated once this new state is triggered from another new state with + button
			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserSalesFilterListDto */
		/* to access: ui-ref="user-salesfilter.list" */
		/* url: http://<hostname>/user/salesfilter/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-list-user.html',
				controller: 'UserSalesFilterListDtoController',
			},
		},
	};

	$stateProvider.state('user-salesfilter.list', dtoListState);

	/* detail state for DTO user */
	var dtoDetailState = {
		/* detail state for DTO UserSalesFilterViewDto */
		/* to access: ui-sref="user-salesfilter.detail" */
		/* url: http://<hostname>/user/salesfilter/detail/:salesFilterId */
		url: '/detail/:salesFilterId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-view-user.html',
				controller: 'SalesFilterDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'UserSalesFilterViewDtoFactory',
				function($stateParams, UserSalesFilterViewDtoFactory) {
					return UserSalesFilterViewDtoFactory.get({ id: $stateParams.salesFilterId });
				},
			],
		},
	};

	$stateProvider.state('user-salesfilter.detail', dtoDetailState);

	/* edit state for DTO user */
	var dtoEditState = {
		/* edit state for DTO UserSalesFilterEditDto */
		/* to access: ui-sref="user-salesfilter.edit" */
		/* url: http://<hostname>/user/salesfilter/edit/:salesFilterId */
		url: '/edit/:salesFilterId',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-edit-user.html',
				controller: 'UserSalesFilterEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserSalesFilterEditDtoFactory',
				function($stateParams, $rootScope, UserSalesFilterEditDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserSalesFilterEditDtoFactory.get({ id: $stateParams.salesFilterId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-salesfilter.edit', dtoEditState);

	/* new (create) state for DTO user */
	var dtoCreateState = {
		/* new state for DTO UserSalesFilterEditDto */
		/* to access: ui-sref="user-salesfilter.new" */
		/* url: http://<hostname>/user/salesfilter/new */
		url: '/new',
		views: {
			'content@': {
				templateUrl: 'app/entities/salesfilter/salesfilter-edit-user.html',
				controller: 'UserSalesFilterEditDtoController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'$rootScope',
				'UserSalesFilterNewDtoFactory',
				function($stateParams, $rootScope, UserSalesFilterNewDtoFactory) {
					// if dataModel is defined, we're coming back from a new created x..1 reference
					if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
						var model = $stateParams.dataModel;

						// reset 'remembered' values to prevent future misbehaviour
						$rootScope.previousStateParams.dataModel = null;
						$stateParams.dataModel = null;

						// instead of returning a new model, we return the updated model
						return model;
					} else {
						return UserSalesFilterNewDtoFactory.get({ id: $stateParams.salesFilterId }).$promise.then(function(result) {
							return result;
						});
					}
				},
			],
		},
	};

	$stateProvider.state('user-salesfilter.new', dtoCreateState);
});
